import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76b780be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-wrapper" }
const _hoisted_2 = { class: "footer-wrapper__inner" }
const _hoisted_3 = { class: "footer-wrapper__inner__copy" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Copyright © BASF SE 2023 ")
const _hoisted_5 = { class: "footer-wrapper__inner__options" }

import { ref } from 'vue';
import { FooterOptions } from '@/constants';
import { version } from '../../package.json';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const footerOptions = ref(FooterOptions);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, "v. " + _toDisplayString(_unref(version)), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerOptions.value, (option, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: idx,
            class: "footer-wrapper__inner__options__option"
          }, [
            _createVNode(_component_router_link, {
              to: option.to
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(option.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})